import { useElementDimensions } from "#clockwise/web-commons/src/util/react.util";
import { RefObject } from "react";

const DEFAULT_NARROW_WIDTH = 420;

const useIsNarrow = (
  ref: RefObject<HTMLDivElement> | undefined,
  narrowWidth = DEFAULT_NARROW_WIDTH,
) => {
  const width = useElementDimensions(ref?.current ?? null)?.width;
  return width < narrowWidth;
};

export default useIsNarrow;
